var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-wrapper d-flex align-items-center justify-content-center"},[_c('coAlert',{staticClass:"mx-3",attrs:{"variant":"grey","size":"sm","text":_vm.$t('chatnotselected')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }